import { THEME_MODE } from "@scaleaq/sui-react/models/constants";
import { TRANSLATION_KEYS } from "src/datahandling/localization/application.i18n";

// *****************************************************
// OBJECTS
// *****************************************************
export const LANGUAGE = {
	norwegian: "no",
	english: "en",
};
export const TRANSLATION = TRANSLATION_KEYS;

export const ENVIRONMENT = {
	dev: "dev",
	stage: "stage",
	prod: "prod",
} as const;

export const INSIGHT_FEATURE = {
	[TRANSLATION.HOME]: "home",
	[TRANSLATION.SETTINGS]: "settings",
} as const;

export const COMPONENT_STATE = {
	default: "default",
	active: "active",
	disabled: "disabled",
	loading: "loading",
	error: "error",
	warning: "warning",
	success: "success",
} as const;

export const DATA_STATUS = {
	UN_FETCHED: "UN_FETCHED",
	MISSING_FETCH_DATA: "MISSING_FETCH_DATA",
	UN_AUTHORIZED: "UN_AUTHORIZED",
	FETCHING: "FETCHING",
	FETCHED: "FETCHED",
	STALE: "STALE",
	ERROR: "ERROR",
} as const;

export const THEME = THEME_MODE;

export const UI_COMPANY_LOADING_KEY = {
	REALTIME_DATA: "REALTIME_DATA",
	REALTIME_AGGREGATE_DATA: "REALTIME_AGGREGATE_DATA",
	COMPANY_SETTINGS: "COMPANY_SETTINGS",
	FEED_PLAN: "FEED_PLAN",
	DEVIATIONS: "DEVIATIONS",
	ACTIVITIES: "ACTIVITIES",
	LOGS: "LOGS",
} as const;

// *****************************************************
// ARRAYS
// *****************************************************

export const THEMES = Object.values(THEME);
export const UI_COMPANY_LOADING_KEYS = Object.values(UI_COMPANY_LOADING_KEY);
export const DATA_STATUSES = Object.values(DATA_STATUS);
export const COMPONENT_STATES = Object.values(COMPONENT_STATE);
export const INSIGHT_FEATURES = Object.values(INSIGHT_FEATURE);
export const ENVIRONMENTS = Object.values(ENVIRONMENT);
export const TRANSLATIONS = Object.values(TRANSLATION);
